import React, { useEffect, useState } from 'react';
import s from './s.module.less';
import AIChat from 'components/AIChat';
import PPAOnboardingHeader from 'components/PPAOnboardingHeader';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';
import { EAIChatPageId } from 'types/ai';
import { Button } from 'antd';
import SuccessImg from './imgs/success.png';
import { saveStep } from 'api/ppaOnboarding';
import { EPPAStep } from 'types/ppaOnboarding';
import { trackHeapEvent } from 'utils/analytics';
import { getCredentialingOverview } from 'api/credentialing';
import { ECredentialingStep } from 'types/credentialing';
import GetCredentialedCard from './components/GetCredentialedCard';

export default function PPAOnboardingFinishPage() {
    const navigate = useNavigate();
    // credentialing 入口卡：只有**已完成** credentialing 的 provider 不再看到这条推荐，
    // 做了一半的人仍然看得到（这张卡也是他们回去续填的入口）。
    // 判定口径与 dashboard 的 CredentialingPage 一致：currentStep 到 CONFIRM/COMPLETED
    // 才算完成 onboarding（到这两步它才渲染 status 页而不是 landing 页）。
    const [showCredentialingCard, setShowCredentialingCard] = useState(false);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const res: any = await getCredentialingOverview();
                const overview = res?.data?.data;
                const finished =
                    overview?.currentStep === ECredentialingStep.CONFIRM ||
                    overview?.currentStep === ECredentialingStep.COMPLETED;
                if (!cancelled && !finished) {
                    setShowCredentialingCard(true);
                    trackHeapEvent('WebApp - PPA Advance Setting Success - View - Get Credentialed Card', {
                        step: EPPAStep.STEP_21,
                    });
                }
            } catch (error) {
                // 状态拿不到就不展示：宁可少推一次，也不要对已经做完 credentialing 的人重复推荐
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    // 页面加载时保存步骤 STEP_21
    useEffect(() => {
        trackHeapEvent('WebApp - PPA Advance Setting Success - View - Page', {
            step: EPPAStep.STEP_21,
        });

        const handleSaveStep = async () => {
            try {
                trackHeapEvent('WebApp - PPA Advance Setting Success - Click - Save Step Attempt', {
                    step: EPPAStep.STEP_21,
                });
                const saveStepRes = await saveStep(EPPAStep.STEP_21);
                if (saveStepRes.error) {
                    trackHeapEvent('WebApp - PPA Advance Setting Success - View - Save Step Failed', {
                        step: EPPAStep.STEP_21,
                        error: saveStepRes.error,
                    });
                    // eslint-disable-next-line no-console
                    console.error('Failed to save step:', saveStepRes.error);
                } else {
                    trackHeapEvent('WebApp - PPA Advance Setting Success - View - Save Step Success', {
                        step: EPPAStep.STEP_21,
                    });
                }
            } catch (error) {
                trackHeapEvent('WebApp - PPA Advance Setting Success - View - Save Step Error', {
                    step: EPPAStep.STEP_21,
                    error: error instanceof Error ? error.message : 'Unknown error',
                });
                // eslint-disable-next-line no-console
                console.error('Error saving step:', error);
            }
        };

        handleSaveStep();
    }, []);

    return (
        <div className={s.wrap}>
            <PPAOnboardingHeader showLogout />
            <div className={s.content}>
                <div className={s.contentWrap}>
                    <div className={s.contentIn}>
                        <img src={SuccessImg} className={s.successImg} alt="success" />
                        <h2>Advanced settings saved successfully!</h2>
                        <div className={s.subTitle}>
                            Your updates have been saved. We’ll notify you once everything is confirmed.
                        </div>
                        <Button
                            onClick={() => {
                                trackHeapEvent('WebApp - PPA Advance Setting Success - Click - Go to Homepage', {
                                    step: EPPAStep.STEP_21,
                                });
                                navigate(`${PATH.DASHBOARD}`);
                            }}
                            type="primary"
                            className={s.goBtn}
                        >
                            Go to homepage
                        </Button>
                        {showCredentialingCard && (
                            <GetCredentialedCard
                                onLearnMore={() => {
                                    trackHeapEvent(
                                        'WebApp - PPA Advance Setting Success - Click - Learn About Credentialing',
                                        { step: EPPAStep.STEP_21 },
                                    );
                                    navigate(`${PATH.DASHBOARD}/${PATH.CREDENTIALING}`);
                                }}
                            />
                        )}
                    </div>
                    <div className={s.chatWrap}>
                        <AIChat
                            pageId={EAIChatPageId.PROVIDER_ONBOARDING_ADVANCE_SETTING_SUCCESS}
                            defaultShow={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
